//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
	props: {
		id: Number,
	},

	computed: {
		itens() {
			if (this.id === 31) {
				this.dados.splice(4, 2)
				return this.dados
			}

			return this.dados
		},
	},

	data: () => ({
		dados: [
			{
				icon: 'check-circle',
				title: 'ESCOLHA SEU CURSO',
				description:
					'Escolha o seu curso e preencha a ficha de inscrição online.',
			},
			{
				icon: 'assign-user',
				title: 'MATRÍCULA',
				description:
					'Após a confirmação do fechamento da turma, realize a matrícula online no link enviado por e-mail.',
			},
			{
				icon: 'event',
				title: 'INÍCIO DAS AULAS',
				description:
					'Após a matrícula receba o cronograma de atividades e acesso ao ambiente virtual de aprendizagem.',
			},
			{
				icon: 'clock',
				title: 'ESTUDE ONDE E COMO QUISER',
				description:
					'Agora é só estudar! Gerencie seu horário de estudos da forma que for mais conveniente a você.',
			},
			{
				icon: 'employee',
				title: 'PROJETOS PROFISSIONAIS APLICADOS',
				description:
					'Durante o curso você coloca a mão na massa, realizando um projeto aplicado ao seu contexto.',
			},
			{
				icon: 'computer',
				title: 'INTERAÇÃO COM SEU PRECEPTOR',
				description:
					'Aproveite ao máximo a interação com seu orientador, por meio dos encontros virtuais periódicos, realizados a cada etapa no projeto.',
			},
			{
				icon: 'crown',
				title: 'MASTER CLASS',
				description:
					'A cada módulo você terá uma master class, que é uma aula online ao vivo (síncrona) com um especialista no assunto.',
			},
		],
	}),
}
